// extracted by mini-css-extract-plugin
export var searchHeader = "_94-0";
export var searchHeaderDark = "_94-1";